import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { SignInPageBlueprint } from '@backstage/plugin-app-react';

// A MODULE this time, not a plugin: unlike the liveness page, this replaces an
// extension the `app` plugin already owns, so it attaches to `app` rather than
// bringing a plugin of its own.
const signInPage = SignInPageBlueprint.make({
  params: {
    loader: async () => (await import('./SignInPage')).SladSignInPage,
  },
});

export const authModule = createFrontendModule({
  pluginId: 'app',
  extensions: [signInPage],
});
